var map = {
	"./TG.png": "0BOG",
	"./TGHover.png": "0aej"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "kHkv";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/funImg ^\.\/TG.*\.png$
// module id = kHkv
// module chunks = 1